import '../Styles/Modal.css';

import { useEffect } from 'react';

export function Modal({message, show, setInfoModal, onModalClose}) {

    useEffect(() => {
        let modal_container = document.getElementById('modal_container');
        if(show) {
            modal_container.classList.add('show');
        }
        else {
            modal_container.classList.remove('show');
            if(onModalClose !== undefined)
                onModalClose();
        }
    }); 

    function closeModal() {
        setInfoModal(false);
    }

    return (
        <div className='modal-container' id='modal_container'>
            <div className='modal'>
                <h1>
                {message}
                </h1>
                <button id="close-modal-button" className="Login-button" onClick={closeModal}><span>OK</span></button>
            </div>
        </div>
    )
}
